module.exports = __webpack_public_path__ + "img/side-of-world.220c0509.png";